module.exports = __webpack_public_path__ + "static/media/map-icon.520ffa2e.svg";